// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicNoLimitScreen-limit-d253{background-color:rgba(249,79,13,.0784313725);border:1px solid rgba(249,79,13,.1607843137);border-radius:8px}`, "",{"version":3,"sources":["webpack://./src/page/BasicNoLimitScreen/BasicNoLimitScreen.module.scss"],"names":[],"mappings":"AAAA,+BACE,4CAAA,CACA,4CAAA,CACA,iBAAA","sourcesContent":[".limit {\n  background-color: #F94F0D14;\n  border: 1px solid #F94F0D29;\n  border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"limit": `BasicNoLimitScreen-limit-d253`
};
module.exports = ___CSS_LOADER_EXPORT___;
